export default (lists = []) => lists.reduce((a, b) => a.concat(b), [])
